export const $ID = '$id';
export const ODATA_ID = '@odata.id';

// SEGMENTS
export const $METADATA = '$metadata';
export const $BATCH = '$batch';
export const $REF = '$ref';
export const $VALUE = '$value';
export const $COUNT = '$count';
export const $QUERY = '$query';
export const $INLINECOUNT = '$inlinecount';

// HTTP HEADERS
export const IF_MATCH_HEADER = 'If-Match';
export const IF_NONE_MATCH_HEADER = 'If-None-Match';
export const CONTENT_TYPE = 'Content-Type';
export const HTTP11 = 'HTTP/1.1';
export const ACCEPT = 'Accept';
export const PREFER = 'Prefer';
export const CACHE_CONTROL = 'Cache-Control';
export const CACHE_CONTROL_HEADERS = [CACHE_CONTROL, CACHE_CONTROL.toLowerCase()];
export const ODATA_VERSION = 'OData-Version';
export const ODATA_VERSION_HEADERS = [
  ODATA_VERSION,
  ODATA_VERSION.toLowerCase(),
  'dataserviceversion',
];
export const LOCATION_HEADER = 'Location';
export const LOCATION_HEADERS = [LOCATION_HEADER, LOCATION_HEADER.toLowerCase()];
export const ODATA_ENTITYID = 'OData-EntityId';
export const ODATA_ENTITYID_HEADERS = [ODATA_ENTITYID, ODATA_ENTITYID.toLowerCase()];
export const PREFERENCE_APPLIED = 'Preference-Applied';
export const PREFERENCE_APPLIED_HEADERS = [PREFERENCE_APPLIED, PREFERENCE_APPLIED.toLowerCase()];
export const ETAG_HEADER = 'ETag';
export const ETAG_HEADERS = [ETAG_HEADER, ETAG_HEADER.toLowerCase()];

export const RETRY_AFTER = 'Retry-After';
export const RETRY_AFTER_HEADERS = [RETRY_AFTER, RETRY_AFTER.toLowerCase()];

// HTTP HEADER VALUES
export const APPLICATION_JSON = 'application/json';
export const APPLICATION_HTTP = 'application/http';
export const APPLICATION_XHTML = 'application/xhtml+xml';
export const APPLICATION_XML = 'application/xml';
export const TEXT_PLAIN = 'text/plain';
export const CONTENT_TYPE_ANY = '*/*';
export const MULTIPART_MIXED = 'multipart/mixed';
export const MULTIPART_MIXED_BOUNDARY = 'multipart/mixed;boundary=';
export const CONTENT_TRANSFER_ENCODING = 'Content-Transfer-Encoding';
export const CONTENT_ID = 'Content-ID';
export const MAX_AGE = 'max-age';

// VERSIONS
export const VERSION_4_0 = '4.0';
export const VERSION_3_0 = '3.0';
export const VERSION_2_0 = '2.0';
export const DEFAULT_VERSION = VERSION_4_0;

export const BINARY = 'binary';
export const BOUNDARY_PREFIX_SUFFIX = '--';
export const BATCH_PREFIX = 'batch_';
export const CHANGESET_PREFIX = 'changeset_';
export const DEFAULT_METADATA = 'minimal';
export const DEFAULT_STRIP_METADATA = 'full';
export const DEFAULT_FETCH_POLICY = 'network-only';
export const DEFAULT_MAXAGE = 60; // The default max age for cache entries in seconds
export const CALLABLE_BINDING_PARAMETER = 'bindingParameter';
export const XSSI_PREFIX = /^\)\]\}',?\n/;

// URL PARTS
export const QUERY_SEPARATOR = '?';
export const PARAM_SEPARATOR = '&';
export const VALUE_SEPARATOR = '=';
export const PATH_SEPARATOR = '/';
export const ODATA_PARAM_PREFIX = '$';
export const ODATA_ALIAS_PREFIX = '@';

export const NEWLINE = '\r\n';
export const NEWLINE_REGEXP = /\r?\n/;
export const CACHE_KEY_SEPARATOR = ':';

// Models
export const CID_FIELD_NAME = '_cid';
export const EVENT_SPLITTER = /\s+/;

// Standard vocabularies for annotating OData services
// https://github.com/oasis-tcs/odata-vocabularies/blob/main/vocabularies/Org.OData.Core.V1.md

export const COMPUTED = /.*Computed$/;
export const OPTIMISTIC_CONCURRENCY = /.*OptimisticConcurrency$/;
export const DESCRIPTION = /.*Description$/;
export const LONG_DESCRIPTION = /.*LongDescription$/;
export const OPTIONARL_PARAMETER = /.*OptionalParameter$/;
